var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{attrs:{"dialogName":'AskForIntegration',"closeRight":"-172"}},[_c('div',{staticClass:"pop-up-content-container dialog-boarders"},[_c('div',{attrs:{"data-canny":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }